const roles = {
  listBreadCrumbs: {
    roleManagement: "Roles Management List",
    roleEdit: "Role Edit",
  },
  listFilter: {
    searchRole: "Search by roles name...",
    createRole: "Create New Role",
  },
  listRoles: {
    roleManagement: " Roles Management",
    roleDescription:
      "Roles help setup permissions in a consistent way, which helps keep your workspace secure and compliant.",
    areYouSure: "Are your sure you want to delete this role?",
    addNewRole: "Add New Role",
    editRole: "Edit Role",
    deleteRole: "Delete Role",
    roles: "Roles",
    role: "Role",
    roleEn: "Role Name (English)",
    roleAr: "Role Name (Arabic)",
    update: "Update",
    numberOfUser: "No. of Users",
    status: "Status",
    action: "Action",
    modules: "Modules",
    editPermissions: "Edit Permissions",
    updatePermissions: "Update Permissions",
    showingRange: "Showing {from}-{to} of {total} roles",
    actionOptions: {
      edit: "Edit",
      delete: "Delete",
      disabled: "Disabled",
      enabled: "Enabled",
      view: "View",
    },
    placeholder: {
      rolePlaceholder: "Enter Role",
      noRoleFound: "No Role Found !",
      rolePlaceholderEn: "Enter Role name (english)",
      rolePlaceholderAr: "Enter Role name (arabic)",
    },
    grantAdminPrivilegesPromote:
      "Are you sure you want to grant admin privileges to all role users?",
    grantAdminPrivilegesDemote:
      "Are you sure you want to remove admin privileges from all role users?",
  },
};
export default roles;
